import { useTranslation } from "react-i18next";
import styles from "./riskTables.module.scss";

const DataTable = ({ data, columnName }) => {
  return (
    <div className={styles.tableContainer} style={{ backgroundColor: "white" }}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.firstHeaderCell}>{columnName}</th>
            <th className={styles.headerCell}>Fondo %</th>
            <th className={styles.headerCell}>Categoria %</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => {
            if (row.label !== "1-Mese") {
              return (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.labelCell}>{row.label}</td>
                  <td className={styles.valueCell}>
                    {row.product_value !== "-" ? `${row.product_value}` : "-"}
                  </td>
                  <td className={styles.valueCell}>
                    {row.category_value !== null && row.category_value !== "-"
                      ? `${row.category_value}`
                      : "-"}
                  </td>
                </tr>
              );
            }
          })}
        </tbody>
      </table>
    </div>
  );
};

const RiskTablesContainer = ({ misureDiRischio, rendimentiCumulati }) => {
  const { t } = useTranslation();

  if (misureDiRischio.length === 0 && rendimentiCumulati.length === 0) {
    return null;
  }
  return (
    <>
      <div className={styles.container}>
        <DataTable data={misureDiRischio} columnName="Misure di Rischio" />
        <DataTable data={rendimentiCumulati} columnName="Rend. Cumulati" />
      </div>
    </>
  );
};

export default RiskTablesContainer;
